// Navegação interna do backoffice.
import { NavLink } from 'react-router-dom'
import { Activity, Cpu, Flag, Gauge, Inbox, Users } from 'lucide-react'
import { auditEntries, enumLabel } from './labels'
import '../account/pages.css'

const ITEMS = [
  { to: '/admin', label: 'Início', Icon: Gauge, end: true },
  { to: '/admin/contas', label: 'Contas', Icon: Users, end: false },
  { to: '/admin/filas', label: 'Filas', Icon: Activity, end: false },
  { to: '/admin/flags', label: 'Flags', Icon: Flag, end: false },
  { to: '/admin/ia', label: 'IA', Icon: Cpu, end: false },
  { to: '/admin/contatos', label: 'Contatos do site', Icon: Inbox, end: false },
]

export function AdminNav() {
  return (
    <nav aria-label="Backoffice" className="row wrap" style={{ gap: 8, marginBottom: 20 }}>
      {ITEMS.map(({ to, label, Icon, end }) => (
        <NavLink key={to} to={to} end={end} className={({ isActive }) => `chip ${isActive ? 'on' : ''}`}>
          <Icon size={15} /> {label}
        </NavLink>
      ))}
    </nav>
  )
}

export function AuditTable({ items }: { items: Array<{ id: string; at: string; action: string; actorKind: string; actorEmail: string | null; target: unknown }> }) {
  if (items.length === 0) return <p className="small muted" style={{ padding: 16 }}>Nada registrado ainda.</p>
  return (
    <div className="table-wrap">
      <table className="table stack-sm">
        <thead><tr><th>Quando</th><th>Ação</th><th>Quem</th><th>Detalhes</th></tr></thead>
        <tbody>
          {items.map((a) => {
            const entries = auditEntries(a.target)
            return (
              <tr key={a.id}>
                <td className="small nowrap" data-label="Quando">{new Date(a.at).toLocaleString('pt-BR')}</td>
                <td className="small" data-label="Ação"><code>{a.action}</code></td>
                <td className="small" data-label="Quem">{a.actorEmail ?? enumLabel(a.actorKind)}{a.actorKind === 'staff' && <span className="badge purple" style={{ marginLeft: 6 }}>equipe</span>}</td>
                <td className="small muted audit-detail" data-label="Detalhes">
                  {entries.length === 0 ? '—' : (
                    <div>
                      <ul className="kv-list">{entries.map(([k, v]) => <li key={k}><b>{k}:</b> {v}</li>)}</ul>
                      <details className="raw-json"><summary>Ver JSON completo</summary><pre>{JSON.stringify(a.target, null, 2)}</pre></details>
                    </div>
                  )}
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}
